import { notification } from "antd";
import { onMessage } from "firebase/messaging";
import { useEffect } from "react";
import { useAppDispatch } from "../app/store";
import NotificationPopupIcon from "../assets/icons/NotificationPopupIcon";
import { setNotificationToken } from "../features/auth/authSlice";
import { generateToken, messaging } from "../lib/firebaseConfig";

type MSGType = {
  title: string;
  body: string;
};

export default function useFirebaseNotification() {
  const dispatch = useAppDispatch();
  const [api, contextHolder] = notification.useNotification();

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          // console.log(
          //   "Service Worker registered with scope: ",
          //   registration.scope
          // );
        })
        .catch((error) => {
          console.error("Service Worker registration failed: ", error);
        });
    });
  }

  useEffect(() => {
    generateToken().then((el) => {
      // console.log(el);
      dispatch(setNotificationToken(el));
    });

    const openNotification = (msg: MSGType) => {
      if (msg?.title !== "map") {
        api.open({
          message: msg?.title,
          description: msg?.body,
          icon: <NotificationPopupIcon />,
        });
      }
    };

    // const playSound = () => {
    //   const audio = new Audio(notificationSound);
    //   audio.play();
    // };

    onMessage(messaging, (payload) => {
      const notification = payload?.notification as MSGType;
      openNotification(notification);
      // playSound();
    });
  }, [api, dispatch]);

  return { contextHolder };
}
